export const Roles = {
  AdminITPS: 'AdminITPS',
  AdminQA: 'AdminQA',
  AdminHSE: 'AdminHSE',
  Collaborator: 'Collaborator',
  Trainer: 'Trainer',
};

// Feature switches compiled into the bundle (non-configurable at runtime)
export const SHOW_SPAC_FEATURES = false;

export const Reasons = [
  {key: 0, value: 'Poco tiempo entre creación del curso y vigencia del SOP'},
  {key: 1, value: 'Falta de tiempo debido a volumen de trabajo'},
  {key: 2, value: 'Vacaciones'},
  {key: 3, value: 'Licencia Médica'},
  {key: 5, value: 'Olvidé ingresar al sistema'},
  {key: 4, value: 'Otros'},
];
